import { render } from "./UserCenterChangePassword.vue?vue&type=template&id=eeccbf70"
import script from "./UserCenterChangePassword.vue?vue&type=script&lang=js"
export * from "./UserCenterChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__